import KeyedItem from "../base/item";

export enum CommentTargetType {
  File = "File",
  Workspace = "Workspace",
  Reply = "Reply",
}

export type WorkspaceComment = KeyedItem & {
  content: string;
  userId: string;
  workspaceId: string;
  fileId?: string;
  targetType: CommentTargetType;
  targetId?: string;
  replies?: WorkspaceComment[];
  reactions?: ReactionMap;
};

export type ReactionMap = Record<string, string[]>; // unified -> userId[]
